import { RequestService } from '../api/request-service';
import { EnvironmentService } from '../environment/environment-service';

export class ForgotPasswordService {
  constructor(
    readonly requestService: RequestService,
    readonly environmentService: EnvironmentService
  ) {}

  public async sendForgotPasswordEmail(email: string) {
    const url = this.environmentService.formatUrlNewBackendPublic(
      'send-reset-password-mail'
    );
    url.searchParams.set('email', email);
    return this.requestService.postUnauth(url.toString(), {}); // TODO provide unauthenticated requests
  }
}
